module.exports = __webpack_public_path__ + "static/media/round3.61c72a3f.png";